export function normSearch(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/[\u064B-\u0652\u0640]/g, "")
    .replace(/[أإآٱ]/g, "ا")
    .replace(/ة/g, "ه")
    .replace(/ى/g, "ي")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .replace(/\s+/g, " ")
    .trim();
}

export function toDigits(s) {
  return String(s || "").replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660)).replace(/[\u06F0-\u06F9]/g, (c) => String(c.charCodeAt(0) - 0x06F0)).replace(/\D/g, "");
}

export function nodeText(node) {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(nodeText).join(" ");
  if (node.props) return nodeText(node.props.children);
  return "";
}

const PERSON_KEYS = ["name", "name_en", "full_name", "employee_name", "rider_name", "rider_id", "employee_number", "iqama_number", "id_number",
  "national_id", "phone", "notify_phone", "passport_number", "border_number", "vehicle_number", "plate_number", "email", "platform_id", "keeta_id"];

export function personMatch(x, q) {
  const n = normSearch(q);
  if (!n) return true;
  if (!x) return false;
  const d = toDigits(q);
  const digitQuery = d.length >= 2 && d.length >= n.replace(/[\s\-+#]/g, "").length * 0.6;
  return !!(PERSON_KEYS.some((k) => {
    const v = x[k];
    if (v == null || v === "") return false;
    if (normSearch(v).includes(n)) return true;
    return digitQuery && toDigits(v).includes(d);
  }) || (digitQuery && x.ids && Object.values(x.ids).some((v) => toDigits(v).includes(d))));
}
